<template>
    <default-layout>
        <div class="row">
            <div class="col-12">
                <h1 class="h4 mb-0 clearfix">Integrations</h1>
                <hr>
            </div>
        </div>

        <div class="row">
            <div class="col-4">
                <p class="text-muted">Coming soon...</p>
            </div>
        </div>
    </default-layout>
</template>

<script>
    import DefaultLayout from "../components/layout/DefaultLayout";

    export default {
        name: "IntegrationsPage",
        components: { DefaultLayout }
    }
</script>

<style scoped>

</style>